import React, { useState } from "react";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "./ui/carousel";
import { Dialog, DialogContent, DialogTrigger } from "./ui/dialog";
import { workImages } from "../data/mockData";
import { ChevronLeft, ChevronRight } from "lucide-react";

const WorkSection = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
    setModalOpen(true);
  };

  const handlePrevious = (e) => {
    e.stopPropagation();
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? workImages.length - 1 : prevIndex - 1
    );
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setSelectedImageIndex((prevIndex) =>
      prevIndex === workImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <section id="trabajos" className="py-20 bg-background text-foreground" style={{ paddingBottom: "8rem" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex text-center justify-center items-center gap-4 flex-col mb-12">
          <Badge>Trabajos</Badge>
          <div className="flex gap-2 flex-col">
            <h2 className="text-3xl md:text-5xl tracking-tighter max-w-3xl text-center font-regular">
              Una muestra de nuestra dedicación y calidad
            </h2>
            <p className="text-lg leading-relaxed tracking-tight text-muted-foreground max-w-3xl text-center">
              Cada trabajo es único y lo realizamos con la máxima atención al detalle.
            </p>
          </div>
        </div>

        <Dialog open={modalOpen} onOpenChange={setModalOpen}>
          <Carousel
            opts={{
              align: "start",
              loop: true,
            }}
            className="w-full"
          >
            <CarouselContent>
              {workImages.map((work, index) => (
                <CarouselItem key={work.id} className="basis-5/6 md:basis-1/2 lg:basis-1/4">
                  <div className="p-1">
                    <DialogTrigger asChild onClick={() => handleImageClick(index)}>
                      <Card className="overflow-hidden group cursor-pointer">
                        <CardContent className="p-0 aspect-[3/4] relative flex items-center justify-center">
                          <img
                            src={work.image}
                            alt={work.title}
                            width="300"
                            height="400"
                            loading="lazy"
                            className="w-full h-full object-cover transition-transform duration-500 md:group-hover:scale-110"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                          <div className="absolute bottom-0 left-0 p-4">
                            <h3 className="text-white font-semibold text-lg">{work.title.split("-")[1]}</h3>
                          </div>
                        </CardContent>
                      </Card>
                    </DialogTrigger>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden sm:flex -left-20 lg:-left-24 z-10" />
            <CarouselNext className="hidden sm:flex -right-20 lg:-right-24 z-10" />
          </Carousel>

          <DialogContent className="w-[95vw] sm:max-w-xl md:max-w-2xl lg:max-w-4xl bg-transparent border-none shadow-none flex items-center justify-center">
            {workImages.length > 0 && (
              <div className="relative">
                <img
                  src={workImages[selectedImageIndex].image}
                  alt={workImages[selectedImageIndex].title}
                  loading="lazy"
                  className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black/50 text-white p-4 rounded-b-lg">
                  <p className="text-sm">{workImages[selectedImageIndex].description}</p>
                </div>
                <Button
                  variant="outline"
                  size="icon"
                  className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full h-12 w-12 bg-background/50 hover:bg-background/80 md:left-[-70px]"
                  onClick={handlePrevious}
                >
                  <ChevronLeft className="h-6 w-6" />
                </Button>
                <Button
                  variant="outline"
                  size="icon"
                  className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full h-12 w-12 bg-background/50 hover:bg-background/80 md:right-[-70px]"
                  onClick={handleNext}
                >
                  <ChevronRight className="h-6 w-6" />
                </Button>
              </div>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </section>
  );
};

export default WorkSection;


